export default {
    // API_ENDPOINT: 'http://localhost:8000/api',
    API_ENDPOINT: 'https://lit-taiga-88534.herokuapp.com/api',
    TOKEN_KEY: 'favoreat-client-auth-token',
};